document.addEventListener('DOMContentLoaded', function () {
  const nav = document.querySelector('[data-pikuchi-bottom-nav]');
  if (!nav) return;
  const drawer = document.querySelector('[data-pikuchi-drawer]');
  const openBtn = document.querySelector('[data-pikuchi-menu-toggle]');
  const closeBtn = document.querySelector('[data-pikuchi-close]');
  if (openBtn && drawer) {
    openBtn.addEventListener('click', function () {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (closeBtn && drawer) {
    closeBtn.addEventListener('click', function () {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }
  if (drawer) {
    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }
});
